import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'frame', 'container', 'content', 'title']

  open(event) {
    event.preventDefault()
    const el = event.currentTarget
    const modalUrl = el.dataset.modalUrl
    const url = el.dataset.url

    if (modalUrl) {
      // Turbo-frame modal: load a Rails view (e.g. patient edit form)
      this.frameTarget.addEventListener(
        'turbo:frame-load',
        () => this.dialogTarget.showModal(),
        { once: true }
      )
      this.frameTarget.src = modalUrl
    } else if (url) {
      // Static content modal: show image or PDF (e.g. photo consent)
      const title = el.dataset.title
      if (title && this.hasTitleTarget) this.titleTarget.textContent = title
      const isPdf = el.dataset.contentType === 'application/pdf'
      if (isPdf) {
        this.contentTarget.innerHTML = `<iframe src="${url}" class="w-full rounded" style="min-height:70vh;width:100%"></iframe>`
      } else {
        this.contentTarget.innerHTML = `<img src="${url}" class="max-w-full max-h-screen object-contain rounded" alt="Photo Consent">`
      }
      this.containerTarget.showModal()
    }
  }

  close() {
    if (this.hasContainerTarget && this.containerTarget.open) {
      this.containerTarget.close()
      if (this.hasContentTarget) this.contentTarget.innerHTML = ''
    } else if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.close()
    }
  }

  closeOnBackdrop(event) {
    if (this.hasDialogTarget && event.target === this.dialogTarget) this.close()
    else if (this.hasContainerTarget && event.target === this.containerTarget) this.close()
  }
}
